import { Injectable, Inject} from '@angular/core';

export  class QuotationTripDO {

    public  id:Number = null;

    public  versionId:any = null;

    public  guid:String = null;

    public  createdDt:Date = null;

    public  updatedDt:Date = null;

    public  createdUser:String = null;

    public  updatedUser:String = null;

    public  tripTypeCd:String = null;

    public  tripRegionCd:String = null;

    public  travelFromCountryCd:String = null;

    public  travelToCountryCd:String = null;

    public  travelFromCityCd:String = null;

    public  travelToCityCd:String = null;

    public travelDepartureDt:Date=null;

    public travelReturnDt:Date=null;

    public getId(): Number{
        return this.id;
    }

    public setId(id:Number) {
        this.id=id;
    }

    public getTravelDepartureDt(): Date{
        return this.travelDepartureDt;
    }

    public setTravelDepartureDt(travelDepartureDt:Date) {
        this.travelDepartureDt=travelDepartureDt;
    }

    public getTravelReturnDt(): Date{
        return this.travelReturnDt;
    }

    public setTravelReturnDt(travelReturnDt:Date) {
        this.travelReturnDt=travelReturnDt;
    }

    
    public getGuid():String{
        return this.guid;
    }

    public setGuid(guid:String){
        this.guid=guid;
    }


    public getCreatedDt(): Date{
        return this.createdDt;
    }

    public setCreatedDt(createdDt:Date){
        this.createdDt=createdDt;
    }

    public getUpdatedDt(): Date{
        return this.updatedDt;
    }

    public setUpdatedDt(updatedDt:Date){
        this.updatedDt=updatedDt;
    }

    public getCreatedUser():any{
        return this.createdUser;
    }

    public setCreatedUser(createdUser:any){
        this.createdUser=createdUser;
    }
    
    public getUpdatedUser():any{
        return this.updatedUser;
    }

    public setUpdatedUser(updatedUser:any){
        this.updatedUser=updatedUser;
    }
    public getVersionId():any{
        return this.versionId;
    }

    public setVersionId(versionId:any){
        this.versionId=versionId;
    }

    public getTripTypeCd():String {
		return this.tripTypeCd;
	}

	public setTripTypeCd(tripTypeCd:String) {
		this.tripTypeCd = tripTypeCd;
	}

	public getTripRegionCd():String {
		return this.tripRegionCd;
	}

	public setTripRegionCd(tripRegionCd:String) {
		this.tripRegionCd = tripRegionCd;
	}

	public getTravelFromCountryCd(): String {
		return this.travelFromCountryCd;
	}

	public setTravelFromCountryCd(travelFromCountryCd:String) {
		this.travelFromCountryCd = travelFromCountryCd;
	}

	public getTravelToCountryCd():String {
		return this.travelToCountryCd;
	}

	public setTravelToCountryCd(travelToCountryCd:String) {
		this.travelToCountryCd = travelToCountryCd;
	}

	public getTravelFromCityCd():String {
		return this.travelFromCityCd;
	}

	public setTravelFromCityCd(travelFromCityCd:String) {
		this.travelFromCityCd = travelFromCityCd;
	}

	public getTravelToCityCd():String {
		return this.travelToCityCd;
	}

	public setTravelToCityCd(travelToCityCd:String) {
		this.travelToCityCd = travelToCityCd;
	}


}
